import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { SalesScheduleRoutingModule } from './sales-schedule-routing.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SalesScheduleComponent } from './sales-schedule.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [SalesScheduleComponent],
  imports: [
    CommonModule,
    SharedModule,
    SalesScheduleRoutingModule,
    DragDropModule,
    TranslateModule
  ],
  exports:[TranslateModule]
})
export class SalesScheduleModule { }
